import { render } from "./UserProfileMobileNavbarComponent.vue?vue&type=template&id=683374f1&scoped=true"
import script from "./UserProfileMobileNavbarComponent.vue?vue&type=script&lang=js"
export * from "./UserProfileMobileNavbarComponent.vue?vue&type=script&lang=js"

import "./UserProfileMobileNavbarComponent.vue?vue&type=style&index=0&id=683374f1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\epentilescu\\source\\repos\\Delicitate V2\\front-end\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683374f1"]])

export default __exports__